import type { SearchableSelectOption } from '@/components/ui/SearchableSelect'
import type { ConfiguredReportSelectFilterConfig } from '../types/pages'

export const COMPANY_PROPERTY_SALES_FILTERS: ConfiguredReportSelectFilterConfig[] = [
  {
    kind: 'company',
    key: 'company_id',
    label: 'Company',
    placeholder: 'All Company',
  },
  {
    kind: 'property',
    key: 'property_id',
    label: 'Property',
    placeholder: 'All Property',
  },
  {
    kind: 'salesTeam',
    key: 'fk_sales_team_id',
    label: 'Sales Team',
    placeholder: 'All Sales Team',
  },
]

export const PAYMENT_METHOD_OPTIONS: SearchableSelectOption[] = [
  { value: 'ACH', label: 'ACH' },
  { value: 'PAPER_CHECK', label: 'Paper Check' },
]

export const RENTAL_STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: 'SKIPPED', label: 'Skipped' },
  { value: 'EVICTION', label: 'Eviction' },
]

export const DEFAULT_STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: 'INFO_NEEDED', label: 'Info Needed' },
  { value: 'NO_RESPONSE', label: 'No Response' },
  { value: 'UNDER_LR_REVIEW', label: 'Under Review' },
]

export const CLAIM_STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: 'NOT_STARTED', label: 'Not Started' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'RECEIVED', label: 'Received' },
  { value: 'DENIED', label: 'Denied' },
  { value: 'UNDER_REVIEW', label: 'Under Review' },
  { value: 'RE_OPENED', label: 'Re-Opened' },
  { value: 'VERIFICATION_NEEDED', label: 'Verification Needed' },
  { value: 'LIBERTY_REVIEW', label: 'Liberty Review' },
  { value: 'EXTERNAL_REVIEW', label: 'Level 3 Review' },
  { value: 'PAYMENT_PENDING', label: 'Payment Pending' },
  { value: 'PAID', label: 'Paid' },
  { value: 'CANCELLED', label: 'Cancelled' },
]

export const LOCK_STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: 'EXPIRED', label: 'Expired' },
  { value: 'EXPIRING_SOON', label: 'Expiring Soon' },
  { value: 'LOCKED', label: 'Locked' },
]

export const PROPERTY_STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: '', label: 'Both' },
  { value: '1', label: 'Active' },
  { value: '0', label: 'Not Active' },
]

export const LISTED_STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: '', label: 'All' },
  ...PROPERTY_STATUS_OPTIONS,
]

export const REPORT_TYPE_OPTIONS: SearchableSelectOption[] = [
  { value: 'COMPANY', label: 'Company' },
  { value: 'PROPERTY', label: 'Property' },
]

export const SOURCE_OPTIONS: SearchableSelectOption[] = [
  { value: 'PAYPAL', label: 'PayPal' },
  { value: 'CARDCONNECT', label: 'CardConnect' },
]

export const CHARGEBACK_STATUS_OPTIONS: SearchableSelectOption[] = [
  { value: 'INVESTIGATING', label: 'Investigating' },
  { value: 'CHALLENGED', label: 'Challenged' },
  { value: 'CHARGEBACK_COMPLETE', label: 'Chargeback Complete' },
]

export const PMC_OPTIONS: SearchableSelectOption[] = [
  { value: 'PROPERTY', label: 'Properties' },
  { value: 'COMPANY', label: 'Companies' },
]

export const ROLE_NAME_OPTIONS: SearchableSelectOption[] = [
  { value: 'ROLE_PROPERTY_MANAGER', label: 'Property Manager' },
  { value: 'ROLE_PROPERTY_ADMIN', label: 'Property Assistant' },
  { value: 'ROLE_PROPERTY_AGENT', label: 'Leasing Consultant' },
  { value: 'ROLE_REGIONAL_MANAGER', label: 'Regional Manager' },
  { value: 'ROLE_COMPANY_MANAGER', label: 'Company Manager' },
  { value: 'ROLE_COMPANY_ADMIN', label: 'Company Admin' },
]

export const UPLOADED_OPTIONS: SearchableSelectOption[] = [
  { value: '', label: 'All' },
  { value: '1', label: 'Uploaded' },
  { value: '0', label: 'Not Uploaded' },
]

export const LAST_LOGIN_OPTIONS: SearchableSelectOption[] = [
  { value: '30', label: '10-30 days' },
  { value: '60', label: '30-60 days' },
  { value: '90', label: '60-90 days' },
  { value: '120', label: '90-120 days' },
]

export const DEVICE_OPTIONS: SearchableSelectOption[] = [
  { value: 'Android', label: 'Android' },
  { value: 'iOS', label: 'iOS' },
]

export const ACTION_KEY_OPTIONS: SearchableSelectOption[] = [
  { value: 'app_register', label: 'Register' },
  { value: 'app_login', label: 'Login' },
  { value: 'is_application_complete', label: 'Application Filled' },
  { value: 'app_fee', label: 'App Fee' },
  { value: 'app_access_fee_full', label: 'Access Fee Full' },
]

export const FAILED_LOGIN_TYPE_OPTIONS: SearchableSelectOption[] = [
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'NO_ROLE', label: 'Role Not Assigned' },
  { value: 'INVALID_PASSWORD', label: 'Invalid Password' },
  { value: 'INVALID_USER', label: 'Invalid User' },
]

export const SPECIAL_NOTE_OPTIONS: SearchableSelectOption[] = [
  { value: '', label: 'Special Note' },
  { value: 'Covid_19', label: 'Covid 19' },
]

export const FAILED_LOGIN_TYPE_LABELS = Object.fromEntries(
  FAILED_LOGIN_TYPE_OPTIONS.map((option) => [option.value, option.label]),
)

export const APPLICATION_STATUS_LABELS: Record<string, string> = {
  INCOMPLETE: 'Incomplete',
  COMPLETED: 'Completed',
  APPROVED: 'Approved',
  DENIED: 'Denied',
  CANCELLED: 'Cancelled',
  SUBMITTED: 'Submitted',
  IN_PROGRESS: 'In Progress',
  PENDING: 'Pending',
  PROPERTY_APPROVED: 'Property Approved',
  EXPIRED: 'Expired',
  AWAITING: 'Awaiting',
  NOT_STARTED: 'Not Started',
}
